import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


@Component({
  selector: 'ppl-signed-out',
  standalone: false,
  templateUrl: './signed-out.component.html',
  styleUrl: './signed-out.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignedOutComponent {
  @Input() message: string;

  @Output() signIn = new EventEmitter();

  onSignIn() {
    this.signIn.emit();
  }
}
